export const gridBreakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};
export const gridColumnGap = 24;
export const componentMarginGap = 48;
//# sourceMappingURL=breakpoints.js.map